module.exports = __webpack_public_path__ + "static/media/MA.9574360c.svg";